/************************************************************************************************/
//
// ! Eigentliche Skripte
//


var rwd_menu = 0;
var cachedWidth = jQuery(window).width();

var lazyLoadInstance = 0;


function resizetrigger() {

}

/************************************************************************************************/
//
// ! Scroll-Funktionen
//


function scrollToTop() {

    jQuery(window).scrollTop(jQuery(window).scrollTop() / 1.6);
    if (jQuery(window).scrollTop() > 5) {
        window.setTimeout(scrollToTop, 100);
    } else {
        jQuery(window).scrollTop(0);
    }
}

/************************************************************************************************/
//
// ! Ready
//


jQuery(document).ready(function() {

    lazyLoadInstance = new LazyLoad({});

    jQuery("table").wrap('<div class="table" />');

    resizetrigger();

    jQuery(window).resize(function() {
        var newWidth = jQuery(window).width();
        if (newWidth !== cachedWidth) {
            resizetrigger();
            cachedWidth = jQuery(window).width();
        }
    });

    jQuery("#top a").click(function(e) {
        e.preventDefault();
        scrollToTop();
    });

    jQuery('div.top a').click(function(e) {
        e.preventDefault();
        jQuery('html, body').animate({
            scrollTop: 0
        }, 300);
    });

    new Swiper('.mainSwiper', {
			on: {
				init: function () {
					lazyLoadInstance.update();
				},
            },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },			speed: 800,
			loop: true,
			autoplay: {
				duration: 2000,
			},
        });

    jQuery('.wp-block-mage-liste p.has-button .button.more').click(function () {
            jQuery(this).parent().parent().find('p.later').addClass('show');
            jQuery(this).removeClass('show');
            jQuery(this).parent().find(".less").addClass('show');
        }
    );
        
    jQuery('.wp-block-mage-liste p.has-button .button.less').click(function () {
            jQuery(this).parent().parent().find('p.later').removeClass('show');
            jQuery(this).parent().parent().find('.more').addClass('show');
            jQuery(this).removeClass('show');
            jQuery(this).parent().find(".more").addClass('show');
        }
    );

    jQuery("#rwd_menu_link").click(function() {
        if (jQuery("nav.mobile").hasClass("show")) {
            jQuery("nav.mobile").removeClass("show");
        }else {
            jQuery("nav.mobile").addClass("show");
        }
    })

    jQuery('a[href="#back"]').click(function(e){
        e.preventDefault();
        history.back();
    })

});